"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfUpdateNurseStatePracticeAuthorizationsDto = instanceOfUpdateNurseStatePracticeAuthorizationsDto;
exports.UpdateNurseStatePracticeAuthorizationsDtoFromJSON = UpdateNurseStatePracticeAuthorizationsDtoFromJSON;
exports.UpdateNurseStatePracticeAuthorizationsDtoFromJSONTyped = UpdateNurseStatePracticeAuthorizationsDtoFromJSONTyped;
exports.UpdateNurseStatePracticeAuthorizationsDtoToJSON = UpdateNurseStatePracticeAuthorizationsDtoToJSON;
exports.UpdateNurseStatePracticeAuthorizationsDtoToJSONTyped = UpdateNurseStatePracticeAuthorizationsDtoToJSONTyped;
const AuthorizedStateDto_1 = require("./AuthorizedStateDto");
const LicenseType_1 = require("./LicenseType");
/**
 * Check if a given object implements the UpdateNurseStatePracticeAuthorizationsDto interface.
 */
function instanceOfUpdateNurseStatePracticeAuthorizationsDto(value) {
    if (!('authorizedStates' in value) || value['authorizedStates'] === undefined)
        return false;
    if (!('licenseType' in value) || value['licenseType'] === undefined)
        return false;
    return true;
}
function UpdateNurseStatePracticeAuthorizationsDtoFromJSON(json) {
    return UpdateNurseStatePracticeAuthorizationsDtoFromJSONTyped(json, false);
}
function UpdateNurseStatePracticeAuthorizationsDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'authorizedStates': (json['authorizedStates'].map(AuthorizedStateDto_1.AuthorizedStateDtoFromJSON)),
        'nursysTransactionId': json['nursysTransactionId'] == null ? undefined : json['nursysTransactionId'],
        'licenseType': (0, LicenseType_1.LicenseTypeFromJSON)(json['licenseType']),
    };
}
function UpdateNurseStatePracticeAuthorizationsDtoToJSON(json) {
    return UpdateNurseStatePracticeAuthorizationsDtoToJSONTyped(json, false);
}
function UpdateNurseStatePracticeAuthorizationsDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'authorizedStates': (value['authorizedStates'].map(AuthorizedStateDto_1.AuthorizedStateDtoToJSON)),
        'nursysTransactionId': value['nursysTransactionId'],
        'licenseType': (0, LicenseType_1.LicenseTypeToJSON)(value['licenseType']),
    };
}
//# sourceMappingURL=UpdateNurseStatePracticeAuthorizationsDto.js.map